export const environment = {
    ConventionStatusActive: 1,
    ConventionStatusExpire: "",
    ConventionStatusFerme: 2,
    PathAdresses: "https://geoprod-dev.osm.hotline.direct/fr/q/",
    SirenPath: "https://data.siren-api.fr/",
    api_key: "",
    api_url: "https://api.insurance365-croquettes.bysur.com",
    build: "",
    country: "FR",
    currentCurrency: "EUR",
    dashboardUrl: "https://pbirs.cloud.geoprod.com/",
    decimalPlaces: 3,
    fontFamily_api: "https://www.googleapis.com/webfonts/v1/webfonts?key=",
    formatCurrency: "1.2-2",
    idStatusDefaut: "",
    idStatusEncours: "",
    idStatusImpaye: "",
    idStatusInfoBancaires: "",
    idStatusPaye: "",
    idStatusPlanifie: "",
    id_Doc: "eb160de1de89d9058fcb0b968dbbbd68",
    id_templateDevisFlote: "",
    ipbx_server: "",
    keyFormCompagnie: "compagnie",
    keyFormEntreprise: "morale",
    keyFormGamme: "gamme",
    keyFormOrganisme: "organisme",
    keyFormProspect: "physique",
    keyFormQuality: "qualite",
    keyInstance: "instance",
    key_fontFamily_api: "AIzaSyA8b2eBigqKA4YC4cCHLLSJGu-xzlJAR_Q",
    passwordUnlock: "Y99jseH49KxOwBH",
    production: false,
    sentry_env: "insurance365_croquettes_assurance_preprod",
    sentry_project_dsn: "https://a68a39ad7be548c0004640f439c01a8e@sentry.neopolis-dev.com/28",
    subscription_url: "",
    tarificateurBerilish: "",
    version: "",
    webmail_url: "https://webmail-insurance365-4.bysur.com/apps/mailbox/inbox/1",
};
